import { Component } from "react";
import { AlertTriangle, ArrowLeft, Home } from "lucide-react";

// Écran d'erreur clair (jamais de page blanche) avec retour arrière / accueil
export const ErrorScreen = ({ title, message, testId = "error-screen", onAction }) => {
  const goBack = () => {
    onAction?.();
    if (window.history.length > 1) window.history.back();
    else window.location.assign("/");
  };
  const goHome = () => {
    onAction?.();
    window.location.assign("/");
  };
  return (
    <div className="min-h-screen bg-[#0F172A] text-white flex items-center justify-center px-6" data-testid={testId}>
      <div className="max-w-md w-full text-center space-y-6">
        <div className="w-16 h-16 mx-auto rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center">
          <AlertTriangle className="w-7 h-7 text-[#D4AF37]" />
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-black uppercase tracking-widest" data-testid="error-screen-title">{title}</h1>
          <p className="text-sm text-slate-300" data-testid="error-screen-message">{message}</p>
        </div>
        <div className="flex gap-3 justify-center">
          <button type="button" onClick={goBack} className="rounded-full bg-white/10 hover:bg-white/20 px-5 py-3 text-xs font-black uppercase tracking-widest flex items-center gap-2 transition-colors" data-testid="error-back-btn">
            <ArrowLeft size={14} /> Page précédente
          </button>
          <button type="button" onClick={goHome} className="rounded-full bg-[#D4AF37] text-[#0F172A] px-5 py-3 text-xs font-black uppercase tracking-widest flex items-center gap-2 active:scale-95 transition-transform" data-testid="error-home-btn">
            <Home size={14} /> Accueil
          </button>
        </div>
      </div>
    </div>
  );
};

export const NotFoundPage = () => (
  <ErrorScreen testId="not-found-page" title="Page introuvable" message="Cette page n'existe pas ou a été déplacée. Revenez à la page précédente ou à l'accueil WÔMA." />
);

export class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    // Nouvelle version déployée : les anciens fichiers JS n'existent plus → rechargement unique
    const chunk = /ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module/i.test(String(error?.message || error));
    if (chunk && !sessionStorage.getItem("woma_chunk_reload")) {
      sessionStorage.setItem("woma_chunk_reload", "1");
      window.location.reload();
    }
    console.error("[WÔMA] Erreur d'affichage:", error);
    try {
      const body = JSON.stringify({
        message: String(error?.message || error).slice(0, 500),
        stack: String(error?.stack || "").slice(0, 2000),
        url: window.location.pathname + window.location.search,
      });
      navigator.sendBeacon?.(`${process.env.REACT_APP_BACKEND_URL}/api/client-errors`, new Blob([body], { type: "application/json" }));
    } catch (e) {
      console.debug(e);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorScreen
          title="Oups, un souci d'affichage"
          message="Cette page a rencontré une erreur. Vos données sont en sécurité : revenez en arrière ou retournez à l'accueil."
          onAction={() => this.setState({ error: null })}
        />
      );
    }
    return this.props.children;
  }
}
